import firebase from 'firebase/app';
import 'firebase/messaging';

// Follow this pattern to import other Firebase services
// import { } from 'firebase/<service>';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_API_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// const database = app.database();
// const auth = app.auth();
// const storage = app.storage();

// const databaseRef = database.ref().child('chat');

let messaging: firebase.messaging.Messaging | null = null;

if (firebase.messaging.isSupported()) {
  firebase.initializeApp(firebaseConfig);
  messaging = firebase.messaging();
}

export { messaging };

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('../public/firebase-messaging-sw.js')
//   .then((registration) => {
//           console.log('Registration successful, scope is:', registration.scope);
//       }) .catch((err) => {
//           console.log('Service worker registration failed, error:', err);
//       });
// }

export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    return new Promise((resolve, reject) => {
      navigator.serviceWorker
        .register('./firebase-messaging-sw.js')
        .then((registration) => {
          // registration.addEventListener('updatefound',  () => {
          //   // If updatefound is fired, it means that there's
          //   // a new service worker being installed.
          //   // const installingWorker = registration.installing;
          //   // You can listen for changes to the installing service worker's
          //   // state via installingWorker.onstatechange
          // });

          messaging?.useServiceWorker(registration);
          resolve(registration);
          // request notification permission and get token
          //  console.log('Registration successful, scope is:',
          //  registration.scope);
          // TODO: ask For Permission To Receive Notifications
        })
        .catch((err) => {
          reject(null);
        });
    });
  }
};

export const requestFirebaseNotificationPermission = () =>
  new Promise((resolve, reject) => {
    messaging
      ?.requestPermission()
      .then(() => {
        return messaging?.getToken();
      })
      .then((firebaseToken) => {
        resolve(firebaseToken);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const onMessageListener = () =>
  new Promise((resolve: any) => {
    firebase.messaging().onMessage((payload) => {
      // console.log('Message received. ', payload);
      resolve(payload.data);

      const notification = payload.notification;
      navigator.serviceWorker.getRegistrations().then((registration) => {
        registration[0].showNotification(notification.title);
      });
    });
  });

// // Listen for when child nodes get added to the collection
// databaseRef.on('child_added', function (snapshot) {
//   // Get the chat message from the snapshot and add it to the UI
//   var chat = snapshot.val();
//   addMessage(chat);
// });

// const addMessage = (chat: any) => {
//   console.log('chat', chat);
// };
